import React, { useState, useEffect } from 'react'
import { toast } from "react-toastify"
import { useLocation, useNavigate } from 'react-router-dom';
import { IoText } from "react-icons/io5";
import { BiSolidDownArrow } from "react-icons/bi";
import { MdOutlineTextFields } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { IoIosCheckbox } from "react-icons/io";
import { PiRadioButtonFill } from "react-icons/pi";

import {
  MEDICAL_LIST,
  ADD_MEDICAL,
  UPDATE_MEDICAL,
  MEDICAL_STATUS_CHANGE,
  MEDICAL_DETAILS,
  DELETE_MEDICAL,
  MEDICAL_CATEGORY_LIST
} from '../../../../repository/setup'
import useReduxStore from '../../../../hooks/useReduxStore';
import { adjustPageAfterDeletion, handleTrimmedValue } from '../../../../Utils';

const UseMedicalHistory = () => {

     const { Dispatch, selector: user } = useReduxStore("auth")
    const { Dispatch: patDispatch, selector: PatientData } = useReduxStore("PatientData")
  const navigate = useNavigate()
  const [tab, setTab] = useState('ADDFIELD')
  const [fields, setFields] = useState({})
  const location = useLocation();
  const [spinner, setSpinner] = useState(false)
  const [totalCount, settotalCount] = useState(0)
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: 1 })
  const [medicalHistoryList, setMedicalHistoryList] = useState([])
  const [formCategoryList, setFormCategoryList] = useState([])
  const [filter, setFilter] = useState({ search: "" })
  const [viewFieldsArry, setViewFieldsArry] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [formCategory, setFormCategory] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  // -------------Form Section------------------

  //for patient module
  const [seletedMedicalForm, setSeletedMedicalForm] = useState([])

  const [medicalHistoryModal, setMedicalHistoryModal] = useState({
    open: false,
    data: {}
  })
  const [viewMedicalHistoryModal, setViewMedicalHistoryModal] = useState({
    open: false,
    data: {}
  })

  const [deleteModal, setDeleteModal] = useState({
    open: false,
    data: {}
  })
  const [ShareMedicalHistoryModal, setShareMedicalHistoryModal] = useState({
    open: false,
    data: {}
  })
  const [ChooseMedicalHistoryFomrModal, setChooseMedicalHistoryFomrModal] = useState({
    open: false,
    data: null
  })

  const fieldsArry = [
    { type: "Dropdown", label: "Dropdown", required: true, fieldSize: "col-12", options: [], icon: <BiSolidDownArrow /> },
    { type: "Multiple Choice", label: "Radio", required: true, fieldSize: "col-12", options: [], icon: <PiRadioButtonFill /> },
    { type: "CheckBox", label: "Checkbox", required: true, fieldSize: "col-12", options: [], icon: <IoIosCheckbox /> },
    { type: "Text", label: "Text", required: true, fieldSize: "col-12", options: [], icon: <IoText /> },
    { type: "Title", label: "Title", required: true, fieldSize: "col-12", options: [], icon: <MdOutlineTextFields /> },
    { type: "Date", label: "Date", required: true, fieldSize: "col-12", options: [], icon: <SlCalender /> }
  ]

  const fieldSizeData = [
    { title: "Small", value: "col-4" },
    { title: "Medium", value: "col-6" },
    { title: "Large", value: "col-12" },
  ]


  useEffect(() => {
    if (location.pathname !== '/patient-management') {
      getMedicalHistoryList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controller, location.pathname])

  useEffect(() => {
    getFormCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (viewMedicalHistoryModal?.data?.id || medicalHistoryModal?.data?.id) getDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getMedicalHistoryList = async (isActive) => {
    try {
      let status = 'SAVED'
      if (location.pathname === '/medical_history/draft') status = 'DRAFT'
      let payload = {
        clinicId: user?.clinic_id,
        count: location.pathname !== '/patient-management' ? controller?.rowsPerPage : undefined,
        page: location.pathname !== '/patient-management' ? controller?.page : undefined,
        searchName: filter?.search,
        isDeleted: false,
        status: status,
      }
      if (isActive) {
        payload.isActive = isActive
      }
      setSpinner(true)
      let response = await MEDICAL_LIST(payload)
      setMedicalHistoryList(response?.data)
      settotalCount(response?.count)
    } catch (error) {
      toast.error(error?.message)
      setMedicalHistoryList([])
      settotalCount(0)
    }
    setSpinner(false)
  }

  const getFormCategory = async () => {
    try {
      let payload = {
        clinicId: user?.clinic_id,
        count: 10000,
        isDeleted: false,
        searchName: ""
      }
      setSpinner(true)
      let response = await MEDICAL_CATEGORY_LIST(payload)
      setFormCategoryList(response?.data)
    } catch (error) {
      toast.error(error?.message)
      setFormCategoryList([])
      // settotalCount(0)
    }
    setSpinner(false)
  }

  const copyField = async (val, index) => {
    let newArry = viewFieldsArry
    newArry?.splice(index + 1, 0, val)
    setViewFieldsArry([...newArry]);
  }

  // apply Filter
  const ApplyFilter = () => {
    setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
  }
  // Reset Filter
  const resetFilter = () => {
    setController((pre) => ({ ...pre, page: pre.searchPage, searchPage: 1 }))
    setFilter({ search: "" })
  }

  // Status toggle method
  const status = async (data, toggle = null) => {
    setSpinner(true)
    try {
      let payload = {
        id: data?.id,
        isActive: toggle
      }
      let response = await MEDICAL_STATUS_CHANGE(payload)
      getMedicalHistoryList()
      toast.success(response?.message)
    } catch (err) {
      toast.error(err.message)
    }
    setSpinner(false)
  }

  // ---------------------Form Functnality-----------------------------

  const getDetails = async (id) => {
    try {
      setSpinner(true)
      let response = await MEDICAL_DETAILS(id)
      setFilterStatus(response?.data?.status)
      setTemplateName(response?.data?.name)
      setFormCategory(response?.data?.formCategoryId)
      setViewFieldsArry(response?.data?.fields);
    } catch (error) {
      toast.error(error?.message)
    }
    setSpinner(false)
  }

  const handleViewFields = (result, index) => {
    let fieldIndex = viewFieldsArry.length - 1 + 1
    let convertedData = {
      label: result?.label,
      fieldSize: result?.fieldSize,
      required: result?.required,
      options: result?.options,
      type: result?.type,
      FieldIndex: fieldIndex
    };
    setViewFieldsArry([...viewFieldsArry, convertedData]);
    setFields(convertedData);
    setTab('FIELDOPTIONS')
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let finalValue = handleTrimmedValue(value)
    setFields((prevProps) => ({ ...prevProps, [name]: finalValue }));
  };


  const editFieldOption = (val, index) => {
    let options = val?.options?.map((res) => res?.name ? res?.name : res)
    setFields({
      label: val.label,
      fieldSize: val.fieldSize,
      required: val.required,
      options: medicalHistoryModal?.data?.id ? options : val?.options,
      type: val.type,
      FieldIndex: index
    })
    setTab('FIELDOPTIONS')
  }

  const deleteField = (index) => {
    let newArry = viewFieldsArry
    newArry?.splice(index, 1)
    setViewFieldsArry([...newArry]);
    if (!viewFieldsArry.length) setTab('ADDFIELD')
  }

  //  Handle Tags Input
  const handleChange = (value, name) => {
    const filteredValue = value?.filter((item) => item?.trim() !== "");
    setFields((pre) => ({
      ...pre,
      [name]: filteredValue,
    }));
  };

  const handleBlur = (event) => {
    // const { name, value } = event?.target
  }

  const updatedymanicform = () => {
    if (!fields?.label && !fields?.fieldSize) return toast.warn('Please select field')
    viewFieldsArry?.forEach((element, index) => {
      if (fields?.FieldIndex === index) {
        viewFieldsArry[index] = fields;
      }
    });
    setFields({
      label: '',
      fieldSize: '',
      required: false,
      options: '',
      type: '',
      FieldIndex: ''
    })
    // viewFieldsArry?.forEach((element, index) => {
    //     viewFieldsArry[index] = fields;
    // });
    setTab('ADDFIELD')
  }
  const clearForm = () => {
    setViewFieldsArry([]);
    setTemplateName('');
    setFormCategory('');
  }
  // Handle add submit data..!
  const handleAddSubmit = async (type) => {
    if (!formCategory) return toast.warn('Please select form category')
    if (!templateName) return toast.warn('Please enter form name ')
    if (!viewFieldsArry?.length) return toast.warn('Please add atleast 1 field')
    const optionsOnly = viewFieldsArry.filter(obj => obj.type === "Dropdown" || obj.type === "CheckBox" || obj.type === "Multiple Choice").map(obj => obj.options);
    const isEmptyOrNull = optionsOnly.some(options => !options || options.length === 0);
    if (isEmptyOrNull) return toast.warn('Please enter options of field')
    const isLabelText = viewFieldsArry.map((res) => res.label)
    if (isLabelText?.some(str => str === '')) return toast.warn('Please enter label name.');

    // let fields = viewFieldsArry?.map((element, index) => {
    //     if (element.type == "Multiple Choice" && !element?.options?.length) return toast.warn('Please enter options of Radio')
    //     if (element.type == "Dropdown" && !element?.options?.length) return toast.warn('Please enter options of Dropdown')
    //     if (element.type == "CheckBox" && !element?.options?.length) return toast.warn('Please enter options of CheckBox')
    //     return element
    // });
    setSpinner(true)
    let payload = {
      clinicId: user?.clinic_id,
      name: templateName,
      formCategoryId: formCategory,
      status: type,
      // fields: [] = fields
      fields: viewFieldsArry
    }
    try {
      let response = await ADD_MEDICAL(payload)
      if (location.pathname !== '/patient-management') {
        navigate('/medical_history')
        getMedicalHistoryList()
      }
      toast.success(response?.message)
      setMedicalHistoryModal({ data: null, open: false })

    } catch (err) {
      toast.error(err?.message)
    }
    setSpinner(false)
  }

  // Handle Update submit data..!
  const handleupdateSubmit = async (type) => {
    if (!formCategory) return toast.warn('Please select form category')
    if (!templateName) return toast.warn('Please enter form name ')
    if (!viewFieldsArry?.length) return toast.warn('Please add atleast 1 field')

    try {
      // let fields = viewFieldsArry?.map((element, index) => {
      //     // if (element.type == "Multiple Choice" && !element?.options?.length) return toast.warn('Please enter options of Radio')
      //     // else if (element.type == "Dropdown" && !element?.options?.length) return toast.warn('Please enter options of Dropdown')
      //     // else if (element.type == "CheckBox" && !element?.options?.length) return toast.warn('Please enter options of CheckBox')
      //     return element
      // });
      const optionsOnly = viewFieldsArry.filter(obj => obj.type === "Dropdown" || obj.type === "CheckBox" || obj.type === "Multiple Choice").map(obj => obj.options);
      const isEmptyOrNull = optionsOnly.some(options => !options || options.length === 0);
      if (isEmptyOrNull) return toast.warn('Please enter options of field')
      const isLabelText = viewFieldsArry.map((res) => res?.label)
      if (isLabelText?.some(str => str === '')) return toast.warn('Please enter label name.');
      const newFields = viewFieldsArry?.map(item => ({
        ...item,
        options: item?.options?.map(option => option?.name ? option?.name : option)
      }));
      let payload = {
        clinicId: user?.clinic_id,
        id: medicalHistoryModal?.data?.id,
        name: templateName,
        formCategoryId: formCategory,
        status: type ? type : filterStatus,
        fields: newFields
      }
      setSpinner(true)
      let response = await UPDATE_MEDICAL(payload)
      getMedicalHistoryList()
      toast.success(response?.message)
      if (type === "DRAFT") {
        navigate('/medical_history/draft')
      } else {
        navigate('/medical_history')
      }
      setMedicalHistoryModal({ data: null, open: false })
    } catch (err) {
      toast.error(err?.message)
    }
    setSpinner(false)
  }

  // Handle delete category..!
  const handleDelete = async (event) => {
    setSpinner(true)
    let payload = {
      clinicId: user?.clinic_id,
      id: deleteModal?.data?.id,
      isDeleted: true
    }
    try {
      let response = await DELETE_MEDICAL(payload)
      setDeleteModal({ data: {}, open: false })
      adjustPageAfterDeletion({
        totalCount: totalCount,
        currentPage: controller.page,
        rowsPerPage: controller.rowsPerPage,
        onPageChange: (newPage) => setController((prev) => ({ ...prev, page: newPage })),
        onTotalCountChange: (newTotal) => settotalCount(newTotal),
      });
      await getMedicalHistoryList()
      setTimeout(() => {
        toast.success(response?.message)
      }, 500)
    } catch (err) {
      toast.error(err?.message)
    }
    setSpinner(false)
  }

  // for patient module
  const handleSelectMedicalForm = (e, item) => {
    const { checked } = e.target
    setSeletedMedicalForm(prevSelectedItems =>
      checked ? [...prevSelectedItems, item] : prevSelectedItems.filter(selectedItem => selectedItem !== item)
    );
  }


  return {
    data: {
      location,
      spinner,
      controller,
      totalCount,
      medicalHistoryList,
      formCategoryList,
      medicalHistoryModal,
      viewMedicalHistoryModal,
      filterStatus,
      viewFieldsArry,
      filter,
      deleteModal,
      templateName,
      formCategory,
      // ---------------Form data
      Permission: user,

      fieldsArry,
      fieldSizeData,
      fields,
      tab,
      //  for patinet
      ShareMedicalHistoryModal,
      seletedMedicalForm,
      ChooseMedicalHistoryFomrModal,
      patientDetails: PatientData,
    },
    methods: {
      setMedicalHistoryModal,
      setViewMedicalHistoryModal,
      setTab,
      settotalCount,
      setController,
      setMedicalHistoryList,
      setFormCategoryList,
      setFormCategory,
      setTemplateName,
      status,
      setFilter,
      ApplyFilter,
      resetFilter,
      setViewFieldsArry,
      copyField,
      setDeleteModal,
      // -----------------------Form methods ---------------
      handleInputChange,
      handleBlur,
      handleAddSubmit,
      getDetails,
      handleupdateSubmit,
      handleDelete,
      setFilterStatus,
      handleViewFields,
      setFields,
      editFieldOption,
      deleteField,
      handleChange,
      updatedymanicform,
      clearForm,
      setSpinner,
      // for patient
      setShareMedicalHistoryModal,
      handleSelectMedicalForm,
      setSeletedMedicalForm,
      getMedicalHistoryList,
      setChooseMedicalHistoryFomrModal
    }
  }
}

export default UseMedicalHistory
